import HttpClient from "../services/interfaces/HttpClient";
import axios, {AxiosRequestConfig, AxiosResponse} from "axios";
import {serverResponseNoData, serverResponseSuccessCode} from "../model/ServerResponse";

// TODO: Cover all potential cases of response.data.data that are false
export class AxiosHttpClient implements HttpClient {

    public async get<T>(url: string): Promise<T> {
        let response = await axios.get(url);
        this.checkResponse(response);
        if (!response.data.data && response.data.data !== 0) {
            throw new Error(serverResponseNoData);
        }

        return response.data.data;
    }

    public async getStream<T>(url: string, config: AxiosRequestConfig): Promise<T> {
        let response = await axios.get(url, config);
        this.checkResponse(response);
        if (!response.data) {
            throw new Error(serverResponseNoData);
        }

        return response.data;
    }

    public async post<T>(url: string, body: any, config?: AxiosRequestConfig): Promise<T> {
        let response = await axios.post(url, body);
        this.checkResponse(response);
        if (!response.data.data) {
            throw new Error(serverResponseNoData);
        }

        return response.data.data;
    }

    public async delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
        let response = await axios.delete(url);
        this.checkResponse(response);
        if (!response.data.data) {
            throw new Error(serverResponseNoData);
        }

        return response.data.data;
    }

    private checkResponse(response: AxiosResponse): void {
        if (!response) {
            throw new Error('null');
        } else if (response.status >= 300) {
            throw new Error(`${response.status}`);
        } else if (response.data.responseCode !== serverResponseSuccessCode) {
            throw new Error(`${response.data.responseCode}: ${response.data.responseMessage}`);
        }
    }
}

const _http_client = new AxiosHttpClient();

export default _http_client;